import React, { useEffect, useLayoutEffect, Fragment, useState } from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import { slickDot } from "../page-demo/script";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import ServiceList from "../elements/service/ServiceList";
import FooterTwo from "../component/footer/FooterTwo";
import Contact from "../elements/contact/ContactTwo";
import Helmet from "../component/common/Helmet";
import logoXrai from "../assets/images/logo/xrailogo.png";
import logoLight from "../assets/images/logo/logo-light.png";
import logoAllDark from "../assets/images/logo/logo-all-dark.png";
import aboutImg from "../assets/images/about/about.png";
import TabsTwo from "../elements/tab/TabTwo";
import { TestLoginAPI } from "../api/login/LoginApi";
import { useHistory } from "react-router-dom";
import { TokenName, TokenTime } from "../util/Common";
import { getCookie, setCookie } from "../util/Cookie";
import { ApiProducts } from "../api/apiKey/ApiProducts";
import { useSetRecoilState } from "recoil";
import { apiProductsState } from "../atom/Products";
import { ApiList } from "../api/apiKey/ApiList";
import { apiKeyState } from "../atom/ApiKey";
import {
  KAKAOCLIENTID,
  KAKAONONCE,
  KAKAOREDRIECTURL,
  KAKAOSCOPES,
  KAKAOSTATE,
} from "../util/KakaoLoginUtil";

const SlideList = [
  {
    textPosition: "text-center",
    category: "",
    title: "eXplainable Reliable AI",
    description: "사업화를 위한 AI솔루션이 필요하신가요?",
    description2:
      "XRAI는 고객이 원하는 서비스를 제공하기까지 최선을 다하여 프로젝트를 끝까지 도와드립니다.",
    buttonText: "Contact Us",
    buttonLink: "#contact",
  },
];
const list = [
  {
    image: "image-1",
    category: "모하(MOHA)",
    title: "유아 사진 자동 분류 서비스",
  },
  {
    image: "image-2",
    category: "피쉬렌즈",
    title: "어종검출어플리케이션",
  },
  {
    image: "image-3",
    category: "후원한잔",
    title: "블로그 후원서비스",
  },
  {
    image: "image-4",
    category: "AI 프로필",
    title: "AI 캐리커쳐 생성",
  },
  {
    image: "image-5",
    category: "Vibe Up",
    title: "SNS 서비스",
  },
  {
    image: "image-6",
    category: "API 서비스",
    title: "건강 데이터 조회",
  },
  {
    image: "image-7",
    category: "API 서비스",
    title: "광학문자 인식 서비스",
  },
  {
    image: "image-8",
    category: "Bot",
    title: "Chat Bot 제작 서비스",
  },
];

const LoginPage = () => {
  const location = useLocation();
  const history = useHistory();
  const setApiProducts = useSetRecoilState(apiProductsState);
  const setApiKey = useSetRecoilState(apiKeyState);
  const [isEmail, setEmail] = useState("");
  const [isTest, setTest] = useState(false);
  const Kakao = window.Kakao;

  useEffect(() => {
    const token = getCookie(TokenName);

    if (!token) {
    } else {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    if (Kakao && !Kakao.isInitialized()) {
      Kakao.init(KAKAOCLIENTID);
    }
  }, []);

  const kakaoHandleLogin = () => {
    Kakao.Auth.authorize({
      redirectUri: KAKAOREDRIECTURL,
      state: KAKAOSTATE,
      scope: KAKAOSCOPES,
      nonce: KAKAONONCE,
    });
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleTestLogin = async (email) => {
    try {
      const resp = await TestLoginAPI(email);

      if (resp.status === 200) {
        const token = resp.data.access_token;
        setCookie(TokenName, token, {
          path: "/",
          maxAge: TokenTime,
        });

        // const apipro = await ApiProducts();

        // const apiKey = await ApiList();

        // if (apipro?.data) {
        //   setApiProducts(apipro?.data);
        // }

        // if (apiKey?.data) {
        //   setApiKey(apiKey?.data);
        // }

        history.push("/");
      }
    } catch (error) {
      console.log("error", error);
      return;
    }
  };

  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };

  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
        </div>
      </header>
      {/* End Header Area  */}

      {/* Start Slider Area   */}
      <div className="slider-activation slider-creative-agency" id="home">
        <div
          className="bg_image bg_image--main"
          style={{
            // height: `100vh`,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`,
          }}
          data-black-overlay="6"
        >
          <div>
            {SlideList.map((value, index) => (
              <div
                className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center"
                key={index}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div
                        className={`inner ${value.textPosition}`}
                        style={{
                          display: `flex`,
                          flexDirection: `column`,
                          justifyContent: `center`,
                          alignItems: `center`,
                        }}
                      >
                        {value.category ? <span>{value.category}</span> : ""}
                        {value.title ? (
                          <h1
                            className="title theme-gradient"
                            style={{ "text-transform": "none" }}
                          >
                            {value.title}
                          </h1>
                        ) : (
                          ""
                        )}
                        {value.description ? (
                          <p
                            className="description"
                            style={{ fontWeight: `bold` }}
                          >
                            {value.description}
                          </p>
                        ) : (
                          ""
                        )}
                        {value.description2 ? (
                          <p
                            className="description"
                            style={{ padding: "0", fontWeight: `bold` }}
                          >
                            {value.description2}
                          </p>
                        ) : (
                          ""
                        )}
                        <div
                          style={{
                            height: `30%`,
                            width: `20%`,
                            minWidth: `350px`,
                            borderRadius: `8px`,
                            backgroundColor: `rgba(255, 255, 255, 0.6)`, // ← 배경 투명도
                            backdropFilter: `blur(10px)`, // ← 블러 효과
                            WebkitBackdropFilter: `blur(10px)`, // ← Safari 호환용
                            border: `1px solid white`,
                            padding: `20px`,
                            marginTop: `30px`,
                          }}
                        >
                          <img
                            className="logo-1"
                            style={logo}
                            src={logoXrai}
                            alt="Logo Images"
                          />
                          <div
                            style={{
                              display: `flex`,
                              justifyContent: `center`,
                              alignItems: `center`,
                              height: `80%`,
                              width: `100%`,
                              flexDirection: `column`,
                              backgroundColor: `transparent`,
                            }}
                          >
                            <div
                              style={{
                                marginTop: `10px`,
                                color: `black`,
                                fontSize: `20px`,
                                fontWeight: `500`,
                              }}
                            >
                              소셜 계정으로 간편 로그인
                            </div>
                            <div style={{ marginTop: `20px` }}>
                              <div className="space-y-4 w-full max-w-[320px]">
                                <button
                                  onClick={kakaoHandleLogin}
                                  className="kakaoButton"
                                >
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                  >
                                    <path
                                      d="M9 1.5C4.5 1.5 0.75 4.34925 0.75 7.8615C0.75 10.1385 2.37825 12.129 4.72275 13.2068L3.78675 16.1033C3.738 16.2653 3.75375 16.4385 3.82725 16.5863C3.9075 16.7498 4.07775 16.8518 4.25925 16.8518C4.383 16.8518 4.50675 16.8068 4.6095 16.719L8.0835 14.3663C8.388 14.3955 8.694 14.412 9 14.412C13.5 14.412 17.25 11.5628 17.25 8.0505C17.25 4.53825 13.5 1.5 9 1.5Z"
                                      fill="#000000"
                                    />
                                  </svg>
                                  <span
                                    style={{
                                      fontWeight: `800`,
                                    }}
                                  >
                                    카카오로 계속하기
                                  </span>
                                </button>
                                {isTest === true && (
                                  <div>
                                    <input
                                      value={isEmail}
                                      onChange={handleEmail}
                                      style={{
                                        marginTop: `20px`,
                                        backgroundColor: `white`,
                                      }}
                                    ></input>
                                    <div
                                      style={{
                                        display: `flex`,
                                        justifyContent: `center`,
                                        marginTop: `10px`,
                                        width: `100%`,
                                        backgroundColor: `red`,
                                        alignItems: `center`,
                                        color: `white`,
                                        backgroundColor: `blue`,
                                        padding: `5px`,
                                        cursor: `pointer`,
                                        fontWeight: `700`,
                                      }}
                                      onClick={() => handleTestLogin(isEmail)}
                                    >
                                      테스트 로그인
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default LoginPage;
